module.exports = __webpack_public_path__ + "media/images/lp/ashinagasan-ad2/img_data01-3f5be9b79ffef6e8e01b7b5065edd1ff.png";